import React, { useEffect } from "react";
import { useGLTF, useProgress } from "@react-three/drei";
import { useThree } from "@react-three/fiber";

const AtGate = (props) => {
  const gatePath = "/api/Asset/cpat/generic/3dmodels/conditions/CPatGate/Skybox.gltf";

  const { scene } = useGLTF(gatePath);
  const { progress } = useProgress();
  const { camera } = useThree();

  scene.scale.set(1.2, 1.2, 1.2);

  useEffect(() => {
    useGLTF.preload(gatePath);
  }, []);

  useEffect(() => {
    if (progress === 100) {
      props.callBack();
    }
  }, [progress]);

  useEffect(() => {
    camera.updateProjectionMatrix();
  }, [scene]);

  if (!props.visible) {
    return null;
  }

  return <primitive object={scene} />;
};

export default AtGate;
